module.exports = __webpack_public_path__ + "media/assets/svgs/check-29301b2a3ceb676fdd59a627e69c04d8.svg";